import type { RouteRecordRaw } from 'vue-router'

import {
  HomeView,
  AboutView,
  ContactsView,
  DeliveryView,
  PrivacyView,
  TermsView,
  NotFoundView,
} from '@/modules/common/public'
import { HelpView } from '@/modules/help/public'

export const commonRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'ЛабАктив - B2B-платформа для закупки оборудования и материалов',
      description:
        'ЛабАктив помогает компаниям и закупщикам находить оборудование, материалы и расходники, сравнивать позиции и оформлять заказы у поставщиков в одном каталоге.',
      ogImage: '/hero-supply.svg',
      structuredData: 'home',
    },
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
    meta: {
      title: 'О компании',
      description:
        'Узнайте, как ЛабАктив помогает компаниям и поставщикам работать с каталогом оборудования, материалов и расходников, заказами и закупками.',
    },
  },
  {
    path: '/help',
    name: 'help',
    component: HelpView,
    meta: {
      title: 'Помощь',
      description:
        'Справочный центр ЛабАктив: ответы по работе с каталогом, заказами, учетной записью и процессом закупки оборудования и материалов.',
    },
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: ContactsView,
    meta: {
      title: 'Контакты',
      description:
        'Контакты ЛабАктив для закупщиков и поставщиков: свяжитесь с командой платформы по вопросам заказов, каталога и сотрудничества.',
      structuredData: 'organization',
    },
  },
  {
    path: '/delivery',
    name: 'delivery',
    component: DeliveryView,
    meta: {
      title: 'Доставка и оплата',
      description:
        'Условия доставки, оплаты и сопровождения заказов на платформе ЛабАктив для оборудования, материалов и расходников.',
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyView,
    meta: {
      title: 'Политика конфиденциальности',
      description: 'Политика обработки персональных данных и конфиденциальности сервиса ЛабАктив.',
      robots: 'noindex,nofollow',
      index: false,
    },
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsView,
    meta: {
      title: 'Условия использования',
      description: 'Пользовательское соглашение и условия использования платформы ЛабАктив.',
      robots: 'noindex,nofollow',
      index: false,
    },
  },
  {
    path: '/404',
    name: 'not-found',
    component: NotFoundView,
    meta: {
      title: 'Страница не найдена',
      description: 'Запрошенная страница не найдена.',
      robots: 'noindex,nofollow',
      index: false,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
]
